import { ChainId } from '@/constant';
import { computed, makeAutoObservable } from 'mobx';

import { getServerApi } from '@/gql';
import { Config } from '@/gql/graph/__generated__/request';
import user from './user';

interface ChainConfig {
    [ChainId.mainnet]?: Config;
    [ChainId.testnet]?: Config;
}

export class ServerConfig {
    configs: ChainConfig = {
        [ChainId.testnet]: undefined,
    };
    constructor() {
        makeAutoObservable<this>(this);
    }

    @computed get config() {
        return this.configs[user.chainId as keyof ChainConfig];
    }

    getContract = async () => {
        try {
            const api = getServerApi();
            const response = await (api as any).config();

            this.configs[user.chainId as keyof ChainConfig] = response.config;
        } catch (error) {
            console.error('Failed to fetch config detail:', error);
            return null;
        }
    };
}

export default new ServerConfig();
